import React from "react";
import MyTableFilterTypes from "components/MyTableFilter/MyTableFilterTypes";
const Search = React.lazy(() => import("./Types/search"));
const AppMyTableFilter = {
  init() {
    MyTableFilterTypes.addTypes("search_custom", (props) => {
      return <Search {...props} />;
    });
  },
};

export default AppMyTableFilter;
